<div class="image-block">
  <img src={data.src} alt={text} />
  <slot></slot>
</div>


<style>
  .image-block {
    font-size: .8rem;
    line-height: 1rem;
    margin-bottom: 2.5rem;
    color: #d8d8d8;
    /*font-family: "FormularRegular";*/
  }
  img {
    width: 100%;
  }
  .image-container {
    position: relative;
    display: block;
    &:before {
      content: '';
      display: block;
      padding-top: 56.25%;
    }
    img {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
</style>
